import type { StepperInterface } from '@store/stepper/interfaces/stepperInterfaces';

export const selectSteps = (state: { stepper: StepperInterface }) =>
  state.stepper.steps;

export const selectActiveId = (state: { stepper: StepperInterface }) =>
  state.stepper.activeId;

export const selectIsStepperCompleted = (state: {
  stepper: StepperInterface;
}) => state.stepper.completed;
